// extracted by mini-css-extract-plugin
module.exports = {"input__full-width":"PasswordRecovery_input__full-width__1OUeh","inputFullWidth":"PasswordRecovery_input__full-width__1OUeh"};